// extracted by mini-css-extract-plugin
module.exports = {"background_img":"image_background_img__2q7TS","img":"image_img__4cvsa"};